<template>
  <footer class="footer">
    <div class="footer-inside grid-x align-bottom">
      <div
        class="cell align-self-top small-12 large-3"
      >
        <div class="logos">
          <a class="logo-link" href="https://starandgarter.org/" target="_blank">
            <img
              class="logo-img"
              :src="require('@/assets/images/logo-star-and-garter.jpg')"
            />
          </a>
          <a class="logo-link" href="https://www.britishlegion.org.uk/" target="_blank">
            <img
              class="logo-img"
              :src="require('@/assets/images/logo-rbl.jpg')"
            />
          </a>
          <a class="logo-link" href="https://veteranaware.nhs.uk/" target="_blank">
            <img
              class="logo-img"
              :src="require('@/assets/images/logo-veteran-aware.jpg')"
            />
          </a>
        </div>
      </div>
      <div class="cell medium-12 large-6 links">
        <a
          v-for="link in links"
          :key="link.label"
          :href="link.href"
          class="text -t6 -link"
          :class="{ '-hide': link.hideIfInHome && $route.params.homeSlug }"
          >{{ link.label }}</a
        >
      </div>
      <div class="cell large-10 large-offset-1 xlarge-12 xlarge-offset-0">
        <p class="text -t6 copy">
          The Veteran Friendly Framework (VFF) is a project jointly supported by Royal Star & Garter (registered Charity 210119), the Royal British Legion (registered Charity No 219279) and the Veterans Covenant Healthcare Alliance (VCHA).
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          href: "/vff/contact-us/",
          label: "Contact us",
          hideIfInHome: false,
        },
        {
          href: "/vff/terms-and-conditions/",
          label: "Terms & conditions",
          hideIfInHome: false,
        },
        {
          href: "/vff/cookie-policy/",
          label: "Cookie policy",
          hideIfInHome: false,
        },
        {
          href: "/vff/privacy-policy/",
          label: "Privacy policy",
          hideIfInHome: false,
        },
        {
          href: "https://starandgarter.org/complaints/",
          label: "Complaints",
          hideIfInHome: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.footer {
  background-color: #fff;
  padding: 24px 0;
}
.footer-inside {
  border-top: 1px solid #6b2377;
  border-bottom: 1px solid #6b2377;
  padding: 16px 0;
  margin: 0 vw-relative(46);
}
.logos {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 16px;
  @include breakpoint(large) {
    justify-content: flex-start;
    margin-bottom: 0;
  }
}
.logo-img {
  border-left: 1px solid #6b2377;
  margin-left: 10px;
  max-height: 30px;
  max-width: none;
  padding-left: 10px;
  @include breakpoint(large) {
    margin-left: 35px;
    max-height: 35px;
    padding-left: 35px;
  }
}
.logo-link:first-child .logo-img {
  border-left: none;
  margin-left: 0;
  padding-left: 0;
}
.logo-text {
  color: #6b2377;
  margin-bottom: 0.6em;
}
.links {
  text-align: center;
  margin-bottom: 16px;
  @include breakpoint(small only) {
    display: flex;
    flex-wrap: wrap;
  }
  @include breakpoint(large) {
    margin-bottom: 0;
  }
}
.text {
  &.-link {
    color: #6b2377;
    padding: 1em 1em;
    &.-hide {
      display: none;
    }
    @include breakpoint(small only) {
      width: 100%;
    }
  }
}
.supported-by {
  text-align: center;
  line-height: 0;
  @include breakpoint(large) {
    text-align: right;
  }
}
.supported-by-img {
  display: inline-block;
  max-width: 120px;
}
.copy {
  color: #00205b;
  margin-top: 1em;
  text-align: center;
}
</style>
